import { Box, Card, CardContent, List, Skeleton, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginResponse } from "subModule/src/services/userProfile/interface";
import { EnqueueSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { GetFinancesResponse } from "subModule/src/services/bankaccount/interface";
import { useGetFinanceExpensesService } from "subModule/src/services/bankaccount/useBankAccount";
interface AccountsExpensesProps {
    user: LoginResponse | undefined;
    themes: any;
    enqueueSnackbar: EnqueueSnackbar;
    setPLLoading: any;
    profitLossFilters: boolean;
    startDate: any;
    endDate: any;
    setProfitLossFilters: any;
}
export default function AccountsExpenses(props: AccountsExpensesProps) {
    const { t } = useTranslation();
    const firstRender = useRef(true);
    const [data, setData] = useState<any>(null);
    const [loader, setLoader] = useState<boolean>(true);
    const { refetch: apiRefetch } = useGetFinanceExpensesService({ start: props?.startDate, end: props?.endDate });
    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            setTimeout(() => fetchData(), 50);
        }
    }, []);
    useEffect(() => {
        if(props.profitLossFilters) setTimeout(() => fetchData(), 100);
    }, [props.profitLossFilters]);
    const fetchData = async () => {
        props.setPLLoading(true);
        setLoader(true);
        await apiRefetch().then((res: GetFinancesResponse | unknown | any) => {
            if (res?.data?.success) {
                setData(res?.data?.data || {});
            } else {
                props.enqueueSnackbar(<AlertMessages text={res?.data?.message || "Something went wrong"} />, { variant: "error" });
            }
        }).catch((err: any) => {
            console.error("===", err);
        }).finally(() => {
            props.setPLLoading(false);
            props.setProfitLossFilters(false);
            setLoader(false);
        });
    };
    const formattedData = data ? Object.entries(data || []).map(([name, value]) => ({ name, value })) : [];
    const total = formattedData.reduce((sum, item) => {
        const num = Number(item?.value);
        return sum + (isNaN(num) ? 0 : num);
    }, 0);
    return (
        <Card sx={{ height: '250px', boxShadow: 'none', borderRadius: '8px', '& .MuiCardContent-root': { padding: '16px 0 !important' } }}>
            <CardContent>
                <Box className={`flex gap-1 items-center justify-between px-[16px] mb-[20px]`}>
                    <Typography variant="h1" gutterBottom className="font-Saira text-[15px] font-extrabold">{t('expenses')}</Typography>
                    {loader ? <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary, width: '200px' }} /> : <Tooltip followCursor title={total?.toLocaleString() || '-'}>
                        <Typography variant="h2" gutterBottom className="font-Saira text-[13px] font-semibold py-[5px] px-[15px] rounded-[99px]"
                            style={{
                                background: total > 0 ? `#4CAF5020` : total < 0 ? `#D32F2F10` : `#00000010`,
                                color: total > 0 ? `#4CAF50` : total < 0 ? `#D32F2F` : `#000000`
                            }}
                        >
                            {total?.toLocaleString() || '-'}{' '}
                            <span className="uppercase">{props?.user?.business?.currency || ''}</span>
                        </Typography>
                    </Tooltip>}
                </Box>
                {loader ? <Box className='px-[16px]'>
                    <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary, marginTop: '-10px' }} />
                    <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary }} />
                    <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary }} />
                    <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary }} />
                    <Skeleton animation="pulse" sx={{ backgroundColor: props?.themes?.secondary }} />
                </Box> : <Box>
                    <List dense className="h-[170px] overflow-y-auto p-0">
                        {(formattedData?.length === 0 || !data) ? <Box className="flex justify-center flex-col">
                            <Typography className="font-Saira text-center italic font-semibold mt-[40px]" sx={{ color: props.themes.primary }}>
                                {t('noRecordFound')}
                            </Typography>
                        </Box>
                            : formattedData?.map((item: any, index: number) => (
                                <li className="pb-[5px] mb-[5px] border-b" key={index}>
                                    <Box className='px-[16px]'>
                                        <Box className="flex justify-between items-center">
                                            <Tooltip followCursor title={t(item.name)}>
                                                <span className="font-Saira text-[12px]">
                                                    {t(item.name)}
                                                </span>
                                            </Tooltip>
                                            <Tooltip followCursor title={item?.value?.toLocaleString() || '-'}>
                                                <span className="font-Saira text-[12px] text-right py-[2px] px-[10px] rounded-[99px]"
                                                    style={{
                                                        background: item?.value > 0 ? `${props.themes.primary}40` : item?.value < 0 ? `#D32F2F10` : `#00000010`,
                                                        color: item?.value > 0 ? `${props.themes.primary}` : item?.value < 0 ? `#D32F2F` : `#000000`
                                                    }}
                                                >
                                                    <span className="font-semibold">{item?.value?.toLocaleString() || '-'}</span>
                                                </span>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </li>
                            )
                            )}
                    </List>
                </Box>
                }
            </CardContent>
        </Card>
    );
}